import React from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextAmount from 'components/text/TextAmount';
import TransactionKey from '../../components/TransactionKey';


const ReturnList = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }
  let returns = data.returns;
  return (
    <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="3" className="text-left calc-setting-table-header">Skilagreinar sem búið er að skila</th>
        </tr>
        <tr>
          <th className="text-left">Færslulykill</th>
          <th className="text-right">Dagsetning</th>
          <th className="text-right">Upphæð</th>
        </tr>
        </thead>
        <tbody>
        {returns.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
              <td className="text-right"><TextDate value={item.returnDate}/></td>
              <td className="text-right"><TextAmount value={item.amount}/></td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

ReturnList.propTypes = {
  data: PropTypes.object,
};

export default ReturnList;
